'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useIsLockedToActivatedDraw } from '../../hooks/useIsLockedToActivatedDraw.js';
import DrawCardPanel from './DrawCard.Panel.js';
/**
 * Bottom panel of a non-selector drawcard.
 *
 * Shows the action button, e.g. 'Byt omgång', unless the user is locked to the current draw and
 * therefore has no use for it.
 *
 * @param root0 input object
 * @param root0.actionButton the action button to display, should be a Button wrapped in TipsenLink.
 * @param root0.role the role of the current user.
 * @returns the panel, or an empty placeholder when there is no action button to show.
 */
export default function DrawCardActionPanel({ actionButton, role }) {
    const isLockedToActivatedDraw = useIsLockedToActivatedDraw(role);
    if (isLockedToActivatedDraw || !actionButton) {
        // The card layout targets its last child, so keep an empty one to leave the other panels evenly sized.
        return _jsx("div", { className: "hidden" });
    }
    return _jsx(DrawCardPanel, { className: "py-[8px]", children: actionButton });
}
//# sourceMappingURL=DrawCard.ActionPanel.js.map